import { attr, belongsTo } from '@ember-data/model';
import ShModel from './sh-model';

const PROCESSORS = {
  BANK: 'bank',
  PAYONEER: 'payoneer',
  PAYONEER_MANUAL: 'payoneer_manual',
  PAYPAL: 'paypal',
  UNKNOWN: 'unknown',
  ZERO: 'zero',
};

const MANUAL_PROCESSORS = [
  PROCESSORS.BANK,
  PROCESSORS.PAYONEER_MANUAL,
  PROCESSORS.PAYPAL,
];

export const SH_PAYMENT_TRANSACTION = {
  PROCESSORS,
  MANUAL_PROCESSORS,
};

const ShPaymentTransaction = ShModel.extend({
  amount: attr('number'),
  createdAt: attr('date'),
  processor: attr('string'),
  processorAccountId: attr('string'),
  processorTransactionId: attr('string'),
  updatedAt: attr('date'),

  //relationships
  shPayment: belongsTo('shInvoice', { async: false }),
});

export default ShPaymentTransaction;
